import { apiBase } from "./apiBase";

export type Brief = {
    id: string;
    name: string;
    fullName: string;
};

export type FormFields = {
    briefId: BriefId;
    subscriberId: SubscriberId;
    subjectLine: string;
    text: string;
    recaptchaResponse: string;
};

export type Params = {
    briefId: BriefId;
    subscriberId: SubscriberId;
};

export const createFormFields = (
    briefId: BriefId,
    subscriberId: SubscriberId,
    subjectLine: string,
    text: string,
    recaptchaResponse: string,
): FormFields => {
    return {
        briefId,
        subscriberId,
        subjectLine,
        text,
        recaptchaResponse,
    };
};

export type SubscriberId = string;
export type BriefId = string;

const subscriberFeedbackApi = apiBase.injectEndpoints({
    endpoints: (builder) => ({
        briefById: builder.query<Brief, BriefId>({
            query: (arg: String) => ({
                url: `/briefs/${arg}`,
            }),
        }),
        submitForm: builder.mutation<void, FormFields>({
            query: (feedbackForm: FormFields) => ({
                url: `/form-submit`,
                body: feedbackForm,
                method: "POST",
            }),
        }),
    }),
});

export const { useBriefByIdQuery, useSubmitFormMutation } = subscriberFeedbackApi;
